const binding = { modules: {}, dataActions: {} };

    (binding.modules['lianxin-menu'] = {
        c: () => require('partner/modules/lianxin-menu/lianxin-menu.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lianxin-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lianxin-menu'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|lianxin-menu|lianxin-menu'] = {
                c: () => require('partner/modules/lianxin-menu/lianxin-menu.view.tsx'),
                cn: '__local__-__local__-lianxin-menu'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };